// usage: {{string | truncate:20}}
export default function format(str, max) {
  if (str && str.length > max) return `${str.slice(0, max)}...`;
  return str;
}
